import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { KaayaIcon } from "@/components/KaayaLogo";
import { startGoogleLogin } from "@/lib/oauth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function SignupInvite() {
  const { code } = useParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const [invite, setInvite] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/invites/${code}`);
        setInvite(data);
        localStorage.setItem("pending_invite_code", code);
        setStatus("ok");
      } catch (e) {
        setStatus("invalid");
      }
    })();
  }, [code]);

  const startLogin = () => {
    startGoogleLogin();
  };

  return (
    <div className="min-h-screen bg-background grain flex items-center justify-center px-6">
      <div className="bg-surface-elevated rounded-3xl border border-border p-10 max-w-md w-full text-center shadow-sm">
        <div className="flex justify-center mb-4"><KaayaIcon size={48} /></div>
        <div className="text-overline">private invite</div>
        <h1 className="font-serif-display text-4xl text-foreground tracking-tight mt-2 mb-4">
          Welcome to KAAYA
        </h1>
        {status === "checking" && <p className="text-muted-foreground">Validating your invite…</p>}
        {status === "invalid" && (
          <>
            <p className="text-destructive mb-4">This invite is invalid or no longer active.</p>
            <Button onClick={() => nav("/")} data-testid="invite-back-home" variant="outline" className="rounded-full">Go home</Button>
          </>
        )}
        {status === "ok" && (
          <>
            {invite?.note && <p className="text-foreground/70 mb-4 italic">"{invite.note}"</p>}
            <p className="text-foreground/80 mb-6 text-sm">
              Sign in with Google to claim your seat and start chatting with your private KAAYA assistant.
            </p>
            <Button onClick={startLogin} data-testid="invite-signin-btn" size="lg"
                    className="rounded-full px-8 bg-primary hover:bg-primary/90 text-primary-foreground">
              Continue with Google
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
